import { translateOrEmpty, addTranslation } from './translations'
import localStorageCache from '../../utils/localStorageCache'
import axios from 'axios'
import { Component } from 'preact'
import TranslationsEdit from '../../preact-components/translations/index'

let batch = []
let batchRequest
let inFlightBatch = batch
let callbacksList = []

const makeRequest = () => {
  const currentBatch = batch
  batch = []
  inFlightBatch = batch
  axios
    .get('/phrase/batch', {
      params: {
        phrases: JSON.stringify(
          currentBatch.map(([module, phrase]) => [module, phrase])
        )
      }
    })
    .then(function ({ data }) {
      inFlightBatch = batch
      currentBatch.forEach(function ([module, phrase, cbList]) {
        let value
        try {
          value = data[module][phrase]
        } catch (error) {
          cbList.forEach(cb => cb())
          return
        }
        localStorageCache.setItem(`${module}|${phrase}`, value)
        addTranslation(module, phrase, value)
        cbList.forEach(cb => cb(translateOrEmpty(module, phrase)))
      })
      callbacksList.forEach(callback => callback())
      callbacksList = []
    })
}

export const fetchPhrase = (module, phrase, cb, batchCb) => {
  const cachedPhrase = localStorageCache.getItem(`${module}|${phrase}`)
  if (cachedPhrase) {
    cb(cachedPhrase)
  }
  const isAlreadyQueued = inFlightBatch.some(
    ([batchedModule, batchedPhrase, cbList]) => {
      if (module === batchedModule && batchedPhrase === phrase) {
        cbList.push(cb)
        return true
      }
    }
  )
  if (isAlreadyQueued) return
  batch.push([module, phrase, [cb]])
  if (batchCb) callbacksList.push(batchCb)
  clearTimeout(batchRequest)
  batchRequest = setTimeout(() => makeRequest(), 50)
}

export default class extends Component {
  constructor (props) {
    super()
    this.fetch(props)
  }

  componentWillReceiveProps () {
    this.fetch(this.props)
  }

  fetch ({ p = 'key', m = 'Forum', count = 0 }) {
    if (translateOrEmpty(m, p, count)) return
    fetchPhrase(m, p, () => {
      this.setState({ isAvailable: translateOrEmpty(m, p, count) })
    })
  }

  render ({ p = 'key', m = 'Forum', count = 0 }) {
    let phrase = translateOrEmpty(m, p, count)
    const isLiveEditing = phrase.match('::phrase::')
    if (!isLiveEditing) return phrase
    return <TranslationsEdit
      translationString={translateOrEmpty(m, p, {})} />
  }
}
